import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { createTrackByFunction } from '@s/angular-utils';

/** Aside link. */
export type AsideLink = {

  /** Path of aside link. */
  readonly path: string;

  /** Link title. */
  readonly title: string;
};

/** Aside component. */
@Component({
  selector: 'sa-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.css'],
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsideComponent {
  /** Track by function for aside link. */
  protected readonly trackLink = createTrackByFunction<AsideLink>('path');

  /** Links. */
  @Input()
  public links: readonly AsideLink[] = [];
}
